import React from "react";
import { connect } from "react-redux";
import { primary } from "../../../../assets/colorPallet";
import { YEARLY, DESCENDANT_ORDER } from "../../../../config";

function DateBar({ currentCompanyAltmanZScore }) {
  
  let array = currentCompanyAltmanZScore?.datesFormatted.filter((value, index) => index >= 11);
  if(currentCompanyAltmanZScore?.prefix === YEARLY) array = currentCompanyAltmanZScore?.yearsFormatted;
      //we change dateArray according to the setting whether it is yearly or monthly

  if(currentCompanyAltmanZScore?.dateOrder == DESCENDANT_ORDER) array = array.slice().reverse();
      //we must reverse the array if dateOrder is descendant order because data in Dupont ratio store is date ascendant

  return (
    <div className="flex items-center font-semibold text-white mt-10 mb-10">
      <div
        style={{ backgroundColor: primary }}
        className="absolute left-0 w-full h-12 z-10"
      />
      <div className="z-20" style={{ minWidth: "22em" }} />
      {array?.map((date) => (
        <div className="z-20" style={{ minWidth: "10em" }}>
          {date}
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyAltmanZScore: state.financialRatios.currentCompanyAltmanZScore
});

export default connect(mapStateToProps)(DateBar);
